export class MobileNetworks {
  static networksLogoPath = {
    MTN_NG : 'assets/img/networks/network-logo-mtn.jpg',
    AIRTEL_NG : 'assets/img/networks/network-logo-airtel.jpg',
    ETISALAT_NG : 'assets/img/networks/network-logo-9mobile.jpg',
    GLO_NG : ' assets/img/networks/network-logo-glo.jpg'
  };

  static networksLogoPathId = [
    {'id': 1, 'codeName': 'MTN_NG', 'logoPath' : 'assets/img/networks/network-logo-mtn.jpg'},
    {'id': 2, 'codeName': 'AIRTEL_NG', 'logoPath' : 'assets/img/networks/network-logo-airtel.jpg'},
    {'id': 3, 'codeName': 'ETISALAT_NG', 'logoPath' : 'assets/img/networks/network-logo-9mobile.jpg'},
    {'id': 4, 'codeName': 'GLO_NG', 'logoPath' : 'assets/img/networks/network-logo-glo.jpg'}
    ]
}



// WEBPACK FOOTER //
// ./src/app/shared/mobile-networks.ts